import React from "react";
import { Text, Button, IButtonProps } from "@atoms";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps extends IButtonProps {
  text?: string;
  isActive?: boolean;
}

// == Constants ============================================================

ToggleButton.defaultProps = {};

// == Component ============================================================

export default function ToggleButton({ text, isActive, children, ...rest }: IProps) {
  return (
    <Button variant={isActive ? "primary" : "clearGrey"} {...rest}>
      {text || children}
    </Button>
  );
}

// == Styles ===============================================================
